import script from "./ComplaintForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintForm.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintForm.vue?vue&type=style&index=0&id=0228bddf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0228bddf"]])

export default __exports__